import { Component, OnInit, ViewChild, AfterViewInit, ContentChildren, TemplateRef, QueryList } from '@angular/core';
import { LanguageService } from '../../services/lang/language.service';
import { IFilterComboComponent, ComboComponent } from 'world-archery-lib';

@Component({
  selector: 'app-filter-lang',
  templateUrl: './filter-lang.component.html',
  styleUrls: ['./filter-lang.component.scss']
})
export class FilterLangComponent implements OnInit, AfterViewInit {

  constructor(public lang_service: LanguageService) {
    (this.lang_service.filtersType[0].options as IFilterComboComponent).options_selected_subject.next(this.lang_service.getLang());
  }

  ngOnInit() {
    (this.lang_service.filtersType[0].options as IFilterComboComponent).options_selected_subject.next(this.lang_service.getLang());
  }

  ngAfterViewInit() {
    (this.lang_service.filtersType[0].options as IFilterComboComponent).options_selected_subject.next(this.lang_service.getLang());
  }

}
